import { I as Icon } from './definition28.js';
import { s as slotted } from './slotted.js';
import { a as attr, o as observable, h as html } from './vivid-element.js';

var __defProp = Object.defineProperty;
var __decorateClass = (decorators, target, key, kind) => {
  var result = void 0 ;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (decorator(target, key, result) ) || result;
  if (result) __defProp(target, key, result);
  return result;
};
const AffixIcon = (Base) => {
  class AffixIconElement extends Base {
  }
  __decorateClass([
    attr
  ], AffixIconElement.prototype, "icon");
  __decorateClass([
    observable
  ], AffixIconElement.prototype, "iconSlottedContent");
  return AffixIconElement;
};
const AffixIconWithTrailing = (Base) => {
  class AffixIconWithTrailingElement extends AffixIcon(Base) {
    constructor() {
      super(...arguments);
      this.iconTrailing = false;
    }
  }
  __decorateClass([
    attr({
      mode: "boolean",
      attribute: "icon-trailing"
    })
  ], AffixIconWithTrailingElement.prototype, "iconTrailing");
  return AffixIconWithTrailingElement;
};
const IconWrapper = {
  Slot: false,
  Span: true
};
const IconAriaHidden = {
  Hidden: "true"};
const affixIconTemplateFactory = (context) => {
  const iconTag = context.tagFor(Icon);
  return (icon, slottedState = IconWrapper.Span, ariaHidden = IconAriaHidden.Hidden, announcement = { label: "", announceOnUpdate: false }) => {
    if (!icon && !slottedState) {
      return html`<slot
				name="icon"
				aria-hidden="${() => ariaHidden}"
				${slotted("iconSlottedContent")}
			></slot>`;
    }
    if (!icon && slottedState) {
      return null;
    }
    const iconTemplate = html`<${iconTag} :name="${() => icon}" :label="${() => announcement?.label || void 0}"></${iconTag}>`;
    const wrapperTag = slottedState ? "span" : "slot";
    return html`<${wrapperTag}
					class="${() => slottedState ? "icon" : void 0}"
					:name="${() => slottedState ? void 0 : "icon"}"
					aria-hidden="${() => announcement?.label ? false : ariaHidden}"
					:role="${() => announcement?.announceOnUpdate ? "status" : void 0}"
					:ariaLive="${() => announcement?.announceOnUpdate ? "polite" : void 0}"
			  >
					${iconTemplate}
			  </${wrapperTag}>`;
  };
};

export { AffixIconWithTrailing as A, IconWrapper as I, affixIconTemplateFactory as a, AffixIcon as b, IconAriaHidden as c };
